<template>
    <div class="filter-box" :class="show ? 'filter-box--show' : ''">
        <div class="filter-box__heading">
            {{trans('search.filter_your_search')}}
        </div>
        <div class="filter-box__content" v-show="show">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../eventbus';

export default {
    data() {
        return {
            show: false
        };
    },

    mounted() {
        EventBus.$on('toggleFilter', show => this.show = show);
    }
};
</script>
